export default __webpack_public_path__ + "static/media/IMG-20230628-WA0074.cff68036.jpg";